import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';
import { UserComplianceSearchStatus } from '../enums/user-compliance-search-status.enum';
import { AUPStates, generateSharedAUPLazyLoadedStates } from '../all-users-progress/states/aup-shared-states-generator';


export type AllUsersProgressLazyLoadedStates = AUPStates<LazyLoadedStates> & {
    base: LazyLoadedStates,
    userCompliance: LazyLoadedStates,
    userComplianceView: LazyLoadedStates,
    userComplianceViewSearch: LazyLoadedStates,
    bulkAdd: LazyLoadedStates
}

export const BASE_ALL_USERS_PROGRESS_DETAILS_STATE_NAME = 'authenticated.all-users-progress.user-compliance.details';
export const BASE_ALL_USERS_PROGRESS_DETAILS_URL = '/details/:userId';

const aupLazyLoadedStates: AUPStates<LazyLoadedStates> = generateSharedAUPLazyLoadedStates(BASE_ALL_USERS_PROGRESS_DETAILS_STATE_NAME, BASE_ALL_USERS_PROGRESS_DETAILS_URL, { forCurrentUser: false });

export const AllUsersProgressLazyLoadedStates = new LazyLoadedStatesManager<AllUsersProgressLazyLoadedStates> ({
    base: {
        name: 'authenticated.all-users-progress',
        abstract: true,
        url: '/all-users-progress'
    },
    userCompliance: {
        name: 'authenticated.all-users-progress.user-compliance',
        abstract: true,
        url: '/user-compliance'
    }, 
    userComplianceView: {
        name: 'authenticated.all-users-progress.user-compliance.view',
        url: '/view/:page?orderBy&ascending'
    }, 
    userComplianceViewSearch: {
        name: 'authenticated.all-users-progress.user-compliance.view.search',
        url: '/?searchBy&status&groups',
        params: {
            searchBy: { 
                raw:true,
                value: '',
            },
            status: {
                raw: true,
                type: 'int',
                value: UserComplianceSearchStatus.ACTIVE
            },
            groups: {
                raw: true,
                type: 'string',
                array: true,
                value: []
            }
        }
    },
    bulkAdd: {
        name: 'authenticated.all-users-progress.bulk-add',
        url: '/bulk-add/:userId'
    },
    ...aupLazyLoadedStates
},
() => import('src/app/all-users-progress/states/all-users-progress/all-users-progress.module').then(mod => mod.AllUsersProgressModule)
);
